// 작은 select/input 공통 클래스(속성 패널 일관) — EditorPage와 그 곁의 편집기 모듈이 공유한다.
// 한 곳에 두는 이유: 같은 칸이 패널마다 다른 결로 보이면 저작 화면이 조각나 보인다.
export const SELECT_CLS =
  'w-full text-xs border border-gray-300 rounded px-1.5 py-1 focus:outline-none focus:ring-1 focus:ring-brand-400';
export const INPUT_CLS = SELECT_CLS;

/**
 * 속성 패널 칸 라벨(코드 값 표기) — BindingRow와, 라벨 행을 스스로 그리는 칸(TemplateVarInput의
 * stacked 배치)이 공유한다. 한 곳에 두지 않으면 같은 라벨이 칸마다 다른 결로 보인다.
 */
export const FIELD_LABEL_CLS = 'text-[11px] text-gray-500 font-mono';
